import React, { useRef, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { useGetUploadUrlMutation } from "@diditusa/shared/api/uploadApi";
import { ImageEntity, ImagePurpose } from "@diditusa/shared/types/uploadsTypes";
import { useAdminCreateProductMutation } from "@diditusa/shared/api/adminApi";
import LoadingIndicator from "@diditusa/shared/web_components/LoadingIndicator/loadingIndicator";

export default function NewProduct() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [pricing, setPricing] = useState("");
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [sendCreateProductReq, sendCreateProductReqState] =
    useAdminCreateProductMutation();

  const [getUploadUrl, { data: uploadUrlResponse, ...getUploadUrlState }] =
    useGetUploadUrlMutation();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    if (file.size >= 5 * 1024 * 1024) {
      alert("Max file size is 5MB");
      return;
    }

    setImageFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result as string);
    reader.readAsDataURL(file);

    const resp = await getUploadUrl({
      purpose: ImagePurpose.PRODUCT,
      entity: ImageEntity.PRODUCT,
      fileName: file.name,
      productId: 123,
    });

    if (!resp.data) {
      alert("error getting upload url");
      console.log((resp.error as any).data.message);
      return;
    }

    try {
      const uploadRes = await fetch(resp.data.signedUrl, {
        method: "PUT",
        body: file.slice(0),
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onSaveClick = async () => {
    await sendCreateProductReq({
      title,
      description,
      price: parseInt(pricing),
    });
  };
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h4" fontWeight="bold" color="#1C1D22" gutterBottom>
        Add New Product Tier
      </Typography>

      <Box display="flex" flexDirection="column" gap={3} maxWidth={480}>
        <TextField
          label="Title"
          variant="outlined"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Tier Title"
          sx={{ backgroundColor: "#EEEFF2", borderRadius: 2 }}
        />
        <TextField
          label="Description"
          variant="outlined"
          fullWidth
          multiline
          minRows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Describe this product tier"
          sx={{ backgroundColor: "#EEEFF2", borderRadius: 2 }}
        />
        <TextField
          label="Pricing"
          variant="outlined"
          fullWidth
          value={pricing}
          onChange={(e) => setPricing(e.target.value)}
          placeholder="Price"
          sx={{ backgroundColor: "#EEEFF2", borderRadius: 2 }}
        />

        {/* <Box
          border="2px dashed #D5D6DD"
          borderRadius={2}
          px={6}
          py={5}
          textAlign="center"
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
        >
          <Typography fontWeight="bold">Product Image</Typography>
          <Typography variant="body2">
            Upload an image for this product
          </Typography>

          {imagePreview && (
            <Avatar
              src={imagePreview}
              alt="Preview"
              variant="rounded"
              sx={{ width: 128, height: 128, my: 2 }}
            />
          )}

          <input
            type="file"
            accept="image/*"
            hidden
            ref={fileInputRef}
            onChange={handleImageChange}
          />
          <Button variant="outlined" onClick={handleUploadClick}>
            Upload Image
          </Button>
        </Box> */}

        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="text"
            sx={{ color: "#1C1D22", fontWeight: "bold", borderRadius: 5 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onSaveClick}
            disabled={sendCreateProductReqState.isLoading}
            sx={{
              bgcolor: "#607AFB",
              color: "#F9FAFA",
              fontWeight: "bold",
              borderRadius: 5,
            }}
          >
            Add Product
          </Button>
          <LoadingIndicator isVisible={sendCreateProductReqState.isLoading} />
        </Box>
        {sendCreateProductReqState.isError && (
          <Typography>
            {(sendCreateProductReqState.error as any).data.message}
          </Typography>
        )}
      </Box>
    </Container>
  );
}
